import {
  EMortgageRateHikeBannerActionTypes,
  ICloseMortgageRateHikeBannerAction,
} from '../../actions/mortgageRateHikeBanner';
import { EMortgageRateHikeBannerStatus } from '../../types/mortgageRateHikeBanner';

export function mortgageRateHikeBannerStatusReducer(
  state: EMortgageRateHikeBannerStatus = EMortgageRateHikeBannerStatus.Available,
  action: ICloseMortgageRateHikeBannerAction,
): EMortgageRateHikeBannerStatus {
  switch (action.type) {
    case EMortgageRateHikeBannerActionTypes.Close:
      return EMortgageRateHikeBannerStatus.ClosedDuringSession;
    default:
      return state;
  }
}
